import _objectSpread from "/Users/lukevoelk/WebstormProjects/OE-UI/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/Users/lukevoelk/WebstormProjects/OE-UI/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/lukevoelk/WebstormProjects/OE-UI/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/lukevoelk/WebstormProjects/OE-UI/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/lukevoelk/WebstormProjects/OE-UI/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/lukevoelk/WebstormProjects/OE-UI/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/lukevoelk/WebstormProjects/OE-UI/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
var DEFAULT_OPTIONS = {
  channelCount: 2,

  /*
   * Bug #105: The channelCountMode should be 'clamped-max' according to the spec but is set to 'explicit' to achieve consistent
   * behavior.
   */
  channelCountMode: 'explicit',
  channelInterpretation: 'speakers',
  pan: 0
};
export var createStereoPannerNodeConstructor = function createStereoPannerNodeConstructor(audioNodeConstructor, createAudioParam, createNativeStereoPannerNode, createStereoPannerNodeRenderer, getNativeContext, isNativeOfflineAudioContext) {
  return /*#__PURE__*/function (_audioNodeConstructor) {
    _inherits(StereoPannerNode, _audioNodeConstructor);

    function StereoPannerNode(context, options) {
      var _this;

      _classCallCheck(this, StereoPannerNode);

      var nativeContext = getNativeContext(context);

      var mergedOptions = _objectSpread({}, DEFAULT_OPTIONS, options);

      var nativeStereoPannerNode = createNativeStereoPannerNode(nativeContext, mergedOptions);
      var isOffline = isNativeOfflineAudioContext(nativeContext);
      var stereoPannerNodeRenderer = isOffline ? createStereoPannerNodeRenderer() : null;
      _this = _possibleConstructorReturn(this, _getPrototypeOf(StereoPannerNode).call(this, context, false, nativeStereoPannerNode, stereoPannerNodeRenderer));
      _this._pan = createAudioParam(_assertThisInitialized(_assertThisInitialized(_this)), isOffline, nativeStereoPannerNode.pan);
      return _this;
    }

    _createClass(StereoPannerNode, [{
      key: "pan",
      get: function get() {
        return this._pan;
      }
    }]);

    return StereoPannerNode;
  }(audioNodeConstructor);
};